import { render, staticRenderFns } from "./edit-patient.vue?vue&type=template&id=662b537e&scoped=true&"
import script from "./edit-patient.vue?vue&type=script&lang=js&"
export * from "./edit-patient.vue?vue&type=script&lang=js&"
import style0 from "./edit-patient.vue?vue&type=style&index=0&id=662b537e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b537e",
  null
  
)

export default component.exports